import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["actionType", "actionContext", "disabled", "onError"];
import { useEffect, useMemo } from 'react';
import { useCrmActionFromLibrary } from 'crm-actions/useCrmActionFromLibrary';
import ButtonCardAction from './ButtonCardAction';
import { jsx as _jsx } from "react/jsx-runtime";
const NO_OP_FUNCTION = () => {};
export default function ActionLibraryButtonAction({
  actionConfig,
  mode,
  overrideLinkModeUse
}) {
  const {
      actionType,
      actionContext,
      disabled,
      onError
    } = actionConfig,
    rest = _objectWithoutPropertiesLoose(actionConfig, _excluded);
  const {
    callback: actionCallback,
    errors
  } = useCrmActionFromLibrary(actionType, actionContext);
  useEffect(() => {
    if (errors && onError) {
      onError(errors);
    }
  }, [errors, onError]);
  const configWithActionFromLibrary = useMemo(() => {
    return Object.assign({}, rest, {
      type: 'button',
      onClick: actionCallback || NO_OP_FUNCTION,
      disabled: disabled || !!errors
    });
  }, [actionCallback, disabled, errors, rest]);
  return /*#__PURE__*/_jsx(ButtonCardAction, {
    actionConfig: configWithActionFromLibrary,
    mode: mode,
    overrideLinkModeUse: overrideLinkModeUse
  });
}